// extracted by mini-css-extract-plugin
export var divider = "_e5-7";
export var itemsToggle = "_e5-8";
export var mergeModal = "_e5-1";
export var optionCard = "_e5-4";
export var radioGroup = "_e5-6";
export var radioOption = "_e5-0";
export var selected = "_e5-5";
export var shipmentOptions = "_e5-2";
export var tableOptions = "_e5-3";